export default __webpack_public_path__ + "static/media/vol7_2.237c4a28.png";